import React from 'react'
import './Loader.css'
const Loader = () => {
  return (
    
        
<div class="load">
  
  <div class="textload">loading...</div>
  <div class="blur-circle"></div>
  <div class="load_gears"> 
    <div class="gear">
      <div class="center"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
    <div class="gear gear-two">
      <div class="center"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
    <div class="gear gear-three">
      <div class="center"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
  </div>
</div>
   
  )
}

export default Loader